module.exports = __webpack_public_path__ + "img/20190826134124360截图20190824150258899.7a288a96.jpg";